import React, { useState } from 'react';
import HorizontalBarChart from './index';

const mockData: IHorizontalBarChartData[] = [
  { name: '产品A', value: 8500 },
  { name: '产品B', value: 6200 },
  { name: '产品C', value: 4100 },
  { name: '产品D', value: 2800 },
  { name: '产品E', value: 1500 },
];

const mockDataWithHighlight: IHorizontalBarChartData[] = [
  { name: '美国', value: 120000 },
  { name: '日本', value: 95000 },
  { name: '韩国', value: 78000 },
  { name: '中国', value: 56000 },
  { name: '英国', value: 42000 },
  { name: '德国', value: 35000 },
  { name: '法国', value: 28000 },
];

/**
 * 基础用法：展示默认配置的横向柱状图
 */
const BasicDemo: React.FC = () => {
  const [loading] = useState(false);

  return (
    <div style={{ width: '100%', height: 300 }}>
      <HorizontalBarChart
        locale="zh-CN"
        loading={loading}
        data={mockData}
        metricName="销量"
        showLabel={true}
        sortByValue={true}
        onBarClick={(params) => {
          console.debug('[HorizontalBarChart] 点击柱子', params);
        }}
      />
    </div>
  );
};

/**
 * 进阶用法：高亮特定数据项，自定义 Tooltip
 */
const AdvancedDemo: React.FC = () => {
  const [loading] = useState(false);

  const handleBarClick = (params: IHorizontalBarChartClickParams): void => {
    console.debug('[HorizontalBarChart] 高级示例点击', params);
  };

  return (
    <div style={{ width: '100%', height: 400 }}>
      <HorizontalBarChart
        locale="zh-CN"
        loading={loading}
        data={mockDataWithHighlight}
        metricName="活跃用户数"
        highlightName="中国"
        showLabel={true}
        sortByValue={true}
        onBarClick={handleBarClick}
        xAxisLabelFormatter={(value) => {
          if (value === null) {
            return '-';
          }
          return `${(value / 1000).toFixed(1)}K`;
        }}
      />
    </div>
  );
};

export const demoConfig = [
  {
    title: '基础用法',
    description: '基本的横向柱状图，展示产品销量排名，支持数值排序和点击交互',
    code: `<HorizontalBarChart
  locale="zh-CN"
  loading={false}
  data={mockData}
  metricName="销量"
  showLabel={true}
  sortByValue={true}
  onBarClick={(params) => {
    console.debug('点击柱子', params);
  }}
/>`,
    element: <BasicDemo />,
  },
  {
    title: '进阶用法 - 高亮与自定义格式化',
    description: '高亮"中国"数据项，自定义 X 轴标签格式为 K 单位，展示各国活跃用户数排名',
    code: `<HorizontalBarChart
  locale="zh-CN"
  loading={false}
  data={mockDataWithHighlight}
  metricName="活跃用户数"
  highlightName="中国"
  showLabel={true}
  sortByValue={true}
  xAxisLabelFormatter={(value) => {
    if (value === null) return '-';
    return \`\${(value / 1000).toFixed(1)}K\`;
  }}
  onBarClick={handleBarClick}
/>`,
    element: <AdvancedDemo />,
  },
];

export default demoConfig;
